<template>
  <div id="app">
    <!--APP-->
    <!--路由占位符-->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>
<style lang="scss" scoped></style>
